import React from "react";
import PulseSelectButton from "../../PulseSelectButton/PulseSelectButton";

interface Step4ConfigurationPropsAndroid {
  programmingLanguage: string;
  onUpdateState: (field: "programmingLanguage", value: string) => void;
}

const Step4ConfigurationAndroid: React.FC<Step4ConfigurationPropsAndroid> = ({
  programmingLanguage,
  onUpdateState,
}) => {
  return (
    <>
      <h1 className="pl-heading-xl">Install SDK</h1>
      <div className="step-content">
        <div className="select-group">
          <h2 className="pl-heading-s">What language will you be using?</h2>
          <div className="side-by-side-buttons">
            <PulseSelectButton
              options={[
                { label: "JAVA", value: "java" },
                { label: "KOTLIN", value: "kotlin" },
              ]}
              value={programmingLanguage}
              onChange={(value) => onUpdateState("programmingLanguage", value)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Step4ConfigurationAndroid;
